module.exports = __webpack_public_path__ + "static/media/pic3.8b3fb00e.jpg";